export default "__VITE_ASSET__I2082JXz__"